import React from "react";
import Reveal from "./Reveal";

const Capabilities = ({ skills }) => (
  <section className="act caps" id="capabilities">
    <div className="act__inner">
      <Reveal>
        <span className="act__num">02 — Yetenekler</span>
      </Reveal>
      <Reveal as="h2" className="act__title" delay={0.05}>
        Kullandığım <em>teknolojiler</em>
      </Reveal>

      <div className="caps__grid" lang="en">
        {skills.map((s, i) => (
          <Reveal
            className="caps__item"
            key={s.name}
            delay={Math.min(i * 0.03, 0.3)}
          >
            <span className="caps__icon">{s.icon}</span>
            <span className="caps__name">{s.name}</span>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Capabilities;
